export const worldMeta = {
  id: "FW-41",
  name: "Nightsignal",
  slug: "nightsignal",
  title: "Nightsignal — a Fable World: music platform page",
  description:
    "An original entertainment landing page designed by Fable: a centered stage, counters that land on one beat, black and magenta."
} as const;

export type WorldMeta = typeof worldMeta;

/**
 * The registry contract: src/worlds/registry.ts globs `world.meta.ts` and reads the
 * NAMED export `meta`. W1-5 shipped these two worlds through their own per-world HTML
 * entry, which read the default export, so `meta` was never here and the glob dropped
 * both worlds silently. Both names are exported now; `meta` is the one that matters.
 */
export const meta = worldMeta;
export default worldMeta;
